import _ from "lodash";
import React from "react";
import classes from "./JumpToSkeletonLoader.scss";
import { CourseFeedSkeletonLoader } from "GlobalHeader/components/JumpToFeature/components/CourseFeed/components";

const JumpToSkeletonLoader = props => {
  const { columnsCount = 3 } = props;
  return (
    <div className={classes.container}>
      {_.times(columnsCount, index => (
        <div key={index} className={classes.columns}>
          <CourseFeedSkeletonLoader
            dummyCourseCount={10}
            showSubtitle={false}
          />
        </div>
      ))}
    </div>
  );
};

export default JumpToSkeletonLoader;
